import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GlobalState } from "contexts/GlobalState";

import "./style.scss";

import SvgGraph from "./svgGraph";
// import Chart from "react-google-charts";
import ReactTooltip from "react-tooltip";

const HIGHEST_SCORE = 800;
const LOWEST_SCORE = 450;

export const PersonalChart = ({ rejectionScore, acceptanceScore, width, height, info, border, current, stats_sentence, calcScore, labels }) => {
  const id = Date.now();
  const [baseFontSize, setBaseFontSize] = useState(16);
  const [randomID, setRandomID] = useState(String(Math.random()))
  const showGraph = (rejectionScore && acceptanceScore);
  const [data, setData] = useState([]);
  const [globalUser, setGlobalUser] = GlobalState("user");
  const userScore = calcScore ?? globalUser?.user?.adapter;

  const findUserStatus = (rejectionScore, acceptanceScore, userScore) => {
    if (userScore > acceptanceScore || userScore == acceptanceScore) {
      return "accepted";
    }
    if (userScore < rejectionScore) {
      return "rejected";
    }
    return "waiting";
  }

  return (
    <Container
      className={`personal-chart  ${border} ${showGraph ? "" : 'hide-graph'}`}
      id={`personal-chart-${id}`}
      aria-label={`personal chart graph, rejection threshold: ${rejectionScore}, acceptance threshold: ${acceptanceScore}, your score: ${current ?? "no score"}`}
      tabIndex="0"> {/*if you want chart to have borders, send border="show" in the props*/}
      {stats_sentence &&
        <Row>
          <Col className="large bold chart-title">{labels.graphTitle}</Col>
        </Row>
      }
      <Row className="chart-row">
        { showGraph &&
          <SvgGraph
            width={263}
            LOWEST_SCORE={LOWEST_SCORE}
            HIGHEST_SCORE={HIGHEST_SCORE}
            rejectionScore={rejectionScore}
            acceptanceScore={acceptanceScore}
            calcScore={calcScore}
          />
        }
      </Row>
      {info &&
        <Row className="info-row">
          <Col>
            <div data-border={true} data-place="left" data-type="light" data-tip data-for={randomID} className="info-wrapper"></div>
          </Col>
        </Row>
      }
      <ReactTooltip id={randomID} place="top" effect="solid" backgroundColor="rgb(255, 251, 251);"	>
        <div tabIndex="0" className="data-titles">
          <p tabIndex="0" aria-label={labels.user_data} className="user-data">{labels.user_data}</p>
          <p tabIndex="0" aria-label={labels.last_year_suitability} className="last-year-suitability">{labels.last_year_suitability}</p>
          <p tabIndex="0" aria-label={labels.current_year_rejection} className="current-year-rejection">{labels.current_year_rejection}</p>
        </div>
        <div tabIndex="0" className="user-data-scores">
          <p tabIndex="0" aria-label={userScore ?? userScore} >{ userScore ?? userScore }</p>
          <p tabIndex="0" aria-label={acceptanceScore ?? acceptanceScore} >{acceptanceScore ?? acceptanceScore }</p>
          <p tabIndex="0" aria-label={rejectionScore ?? rejectionScore} >{rejectionScore ?? rejectionScore }</p>
        </div>
      </ReactTooltip>
    </Container>
  );
};
